"use strict";
/* @preserve
 * https://github.com/Elkfox/Ajaxinate
 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
 * MIT License (do not remove above copyright!)
 */
function Ajaxinate(config) {
    var settings = config || {}
      , defaults = {
        method: "scroll",
        container: "#AjaxinateContainer",
        pagination: "#AjaxinatePagination",
        offset: 0,
        loadingText: "Loading",
        callback: null
    };
    this.settings = Object.assign(defaults, settings),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
    this.preventMultipleClicks = this.preventMultipleClicks.bind(this),
    this.removeClickListener = this.removeClickListener.bind(this),
    this.removeScrollListener = this.removeScrollListener.bind(this),
    this.removePaginationElement = this.removePaginationElement.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.initialize()
}
Ajaxinate.prototype.initialize = function() {
    if (this.containerElement) {
        var initializers = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        initializers[this.settings.method]()
    }
}
,
Ajaxinate.prototype.addScrollListeners = function() {
    this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
    window.addEventListener("resize", this.checkIfPaginationInView),
    window.addEventListener("orientationchange", this.checkIfPaginationInView))
}
,
Ajaxinate.prototype.addClickListener = function() {
    this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.clickActive = !0,
    typeof this.nextPageLinkElement != "undefined" && this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("click", this.preventMultipleClicks))
}
,
Ajaxinate.prototype.preventMultipleClicks = function(event) {
    event.preventDefault(),
    this.clickActive && (this.nextPageLinkElement.innerText = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.clickActive = !1,
    this.loadMore())
}
,
Ajaxinate.prototype.checkIfPaginationInView = function() {
    var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset
      , bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    top <= window.innerHeight && bottom >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.removeScrollListener(),
    this.nextPageLinkElement && (this.nextPageLinkElement.innerText = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.getAttribute("data-next-template"),
    this.loadMore()))
}
,
Ajaxinate.prototype.loadMore = function() {
        var templateID = "AjaxinatePage-" +  this.nextPageUrl;
        var nextTemplateID = "AjaxinatePage-" +  (+this.nextPageUrl + 1);
        var template = document.querySelector("#"+ templateID);
        var nextTemplate = document.querySelector("#"+ nextTemplateID); 
  
        if (template) {
            var content = template.content.cloneNode(true);  
            this.containerElement.appendChild(content);
           if (nextTemplate) {
               this.nextPageLinkElement.setAttribute("data-next-template",(+this.nextPageUrl + 1))
               this.initialize();
            }else{
               this.removePaginationElement();
            }
            
        }else{
          this.removePaginationElement();
        }
    
   }
,
Ajaxinate.prototype.removeClickListener = function() {
    this.nextPageLinkElement.removeEventListener("click", this.preventMultipleClicks)
}
,
Ajaxinate.prototype.removePaginationElement = function() {
    this.paginationElement.innerHTML = "",
    this.destroy()
}
,
Ajaxinate.prototype.removeScrollListener = function() {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
    window.removeEventListener("resize", this.checkIfPaginationInView),
    window.removeEventListener("orientationchange", this.checkIfPaginationInView)
}
,
Ajaxinate.prototype.destroy = function() {
    var destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    return destroyers[this.settings.method](),
    this
}
;
